<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Import Properties'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    <tidy-alert>
      <tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
        <tidy-text
          [header]="'CSV Template'" />
        <tidy-text
          [actionBody]="'Download Example'"
          class="link"
          (action)="downloadCSVTemplate()" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'Address, Unit, City, Zip, Nickname, Country Code'" />
      </tidy-row>
    </tidy-alert>

    @if (!loadedProperties) {
      <tidy-card>
        <tidy-row [alignLastItemRight]="true">
          <tidy-image
            [src]="'assets/img/csv.svg'"
            class="title-size" />
          <tidy-text
            [header]="'Import CSV'" />
          <tidy-text
            (action)="openFilePicker()"
            [body]="'Select CSV'"
            class="link" />
        </tidy-row>
      </tidy-card>
    }

    @if (isLoadingProperties) {
      <tidy-row [align]="'center'">
        <ion-spinner style="width: 50px" class="sc-ion-loading-ios spinner-lines hydrated" /><br>
        <tidy-text
          [body]="'Importing properties. This may take some time.'" />
      </tidy-row>
    }

    @if (showNotCSVError) {
      <tidy-error-message
        [text]="'Please import a CSV file.'" />
    }

    @if (loadedProperties) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/csv.svg'"
            class="header-size" />
          <tidy-text
            [header]="'Import CSV'" />
        </tidy-row>
        @if (properties?.length) {
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/checkmark.svg'"
              class="body-size" />
            <tidy-text
              [body]="properties?.length" /><span>&nbsp;</span>
              <tidy-text
                [body]="'properties ready to be added!'" />
            </tidy-row>
          }
          @if (errorProperties?.length || alreadyUploadedProperties?.length || alreadyAddedProperties?.length) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/img/yellow-alert.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Skipped adding'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="((errorProperties?.length | translate) + (alreadyUploadedProperties?.length | translate) + (alreadyAddedProperties?.length | translate))" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'properties'" />
                </tidy-row>
              }
            </tidy-card>
            @if (properties?.length) {
              <tidy-button
                [text]="'Add Properties'"
                class="primary"
                [action]="boundAddProperties" />
            }
            @if (!properties?.length) {
              <tidy-alert>
                <tidy-row>
                  <tidy-text
                    [body]="'None of your properties were imported successfully. Please download the template above to ensure you have the correct format. Leave the unit or nickname column blank if there is no unit.'" />
                </tidy-row>
              </tidy-alert>
            }
            @if (errorProperties?.length > 0) {
              <tidy-alert>
                <tidy-row>
                  <tidy-image
                    [src]="'assets/img/yellow-alert.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Error Uploading'" />
                </tidy-row>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [body]="'Google Maps did not return any results for the following properties:'" />
                </tidy-row>
                @for (property of errorProperties; track property) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/home.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="property[0]" />
                  </tidy-row>
                }
              </tidy-alert>
            }
            @if (alreadyUploadedProperties?.length > 0) {
              <tidy-alert>
                <tidy-row>
                  <tidy-image
                    [src]="'assets/img/yellow-alert.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Already Added'" />
                </tidy-row>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [body]="'We\'ll skip adding these properties because you already added them to TIDY:'" />
                </tidy-row>
                @for (property of alreadyUploadedProperties; track property) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/home.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="property[0]" />
                  </tidy-row>
                }
              </tidy-alert>
            }
            @if (alreadyAddedProperties?.length > 0) {
              <tidy-alert>
                <tidy-row>
                  <tidy-image
                    [src]="'assets/img/yellow-alert.svg'"
                    class="header-size" />
                  <tidy-text
                    [header]="'Duplicate Imports'" />
                </tidy-row>
                <tidy-row class="extra-bottom-padding">
                  <tidy-text
                    [body]="'You uploading the following properties twice so we\'ll only upload it once:'" />
                </tidy-row>
                @for (property of alreadyAddedProperties; track property) {
                  <tidy-row class="vertical-align-center">
                    <tidy-image
                      [src]="'assets/img/home.svg'"
                      class="body-size" />
                    <tidy-text
                      [body]="property[0]" />
                  </tidy-row>
                }
              </tidy-alert>
            }
            @if (properties?.length > 0) {
              <tidy-row>
                <tidy-text
                  [header]="'Properties to Add:'" />
              </tidy-row>
              @for (property of properties; track property; let i = $index) {
                <tidy-card>
                  <tidy-row [alignLastItemRight]="true">
                    <tidy-image
                      [src]="'assets/img/home.svg'"
                      class="header-size" />
                    <tidy-text
                      [header]="property[0]" />
                    <tidy-text
                      [actionBody]="'X'"
                      (action)="removeProperty(i)"
                      class="link" />
                  </tidy-row>
                  <tidy-row class="vertical-align-center">
                    <tidy-text
                      [body]="'Unit:'" /><span>&nbsp;</span>
                      @if (property[1] !== '') {
                        <tidy-text
                          [body]="property[1]" />
                        }<span>&nbsp;</span>
                        @if (property[1] === '') {
                          <tidy-text
                            [body]="'none'" />
                        }
                      </tidy-row>
                      <tidy-row class="vertical-align-center">
                        <tidy-text
                          [body]="'City:'" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="property[2]" />
                        </tidy-row>
                        <tidy-row class="vertical-align-center">
                          <tidy-text
                            [body]="'Zip:'" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="property[3]" />
                          </tidy-row>
                          <tidy-row class="vertical-align-center">
                            <tidy-text
                              [body]="'Nickname:'" /><span>&nbsp;</span>
                              <tidy-text
                                [body]="property[4]" />
                            </tidy-row>
                            <tidy-row class="vertical-align-center">
                              <tidy-text
                                [body]="'Country Code:'" /><span>&nbsp;</span>
                                <tidy-text
                                  [body]="property[5]" />
                              </tidy-row>
                              <tidy-row class="vertical-align-center">
                                <tidy-text
                                  [body]="'State:'" /><span>&nbsp;</span>
                                  <tidy-text
                                    [body]="property[6]" />
                                </tidy-row>
                              </tidy-card>
                            }
                          }
                        }

                      </tidy-wrapper>
                    </ng-template>

                    @if (!isRightSideContent) {
                      <app-scroll-wrapper [templateContent]="content" />
                    }

                    @if (isRightSideContent) {
                      <ion-content class="ion-content-right-column">
                        <ng-container *ngTemplateOutlet="content" />
                      </ion-content>
                    }
